var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer fixed-bottom"},[_c('NewsTicker'),_c('AppBottomNavBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }